export const defaultCheckListItemN = [
  {
    id: 'analise_taxa',
    label: 'Solicitar uma reanálise da taxa',
  },
];
